import {CategoryBadge} from "react-ui";
import React, {useEffect, useRef} from "react";
import {CategoryModel, Language} from "ts-core";

export interface CategoryBadgeProps {
    categories: CategoryModel[];
    language: Language;
    className?: string;
}
export const CategoryBadges: React.FC<CategoryBadgeProps> = ({categories, language, className = ""}) => {
    const firstCatRef = useRef<HTMLDivElement>(null)
    const [width, setWidth] = React.useState(0);

    useEffect(() => {
        setTimeout(() => {
            if (firstCatRef.current) {
                const bb = firstCatRef.current.getBoundingClientRect();
                const firstCatWidth = bb.width;
                setWidth(firstCatWidth);
            }
        }, 10)
    }, [firstCatRef.current]);


    return <div className={className}>
        {categories.length > 0 && (
            <div className="relative flex">
                {categories.map((c, index) => (
                    <div
                        ref={index === 0 ? firstCatRef : undefined}
                        key={c.id}
                        className="absolute top-0"
                        style={{
                            left: index > 0 ? `${width + (index * 27)}px` : 0,
                            zIndex: categories.length - index,
                            transform: `translateX(${index > 0 ? '-100%' : '0%'})`
                        }}
                    >
                        <CategoryBadge
                            language={language}
                            category={c}
                        />
                    </div>
                ))}
            </div>
        )}
    </div>
}